<template>
  <BaseModalWindow
    :title="changeTags ? 'Редактирование тега внутренней навигации' : 'Редактирование ключевого слова'"
    @closeModal="closeChangeTagsModal"
  >
    <div class="change-tags">
      <div class="tags">
        <div class="tags__input">
          <p>Измените название тега:</p>
          <InputText
            v-if="changeTags"
            style="width: 100%;"
            placeholder="Наименование тега"
            v-model="tagsObj.Name"
            type="text"
            :value="tagsObj.Name"
          />
          <InputText
            v-if="changeTags === false"
            style="width: 300px;"
            placeholder="Наименование тега"
            v-model="keywordsObj.Name"
            type="text"
            :value="keywordsObj.Name"
          />
        </div>
        <div class="tags__buttons">
          <BaseBtnNew
            :blue="true"
            name="Сохранить"
            @clickBtn="saveChangeTags"
          >
            <SaveIconNew/>
          </BaseBtnNew>
          <BaseBtn
          @click="closeChangeTagsModal"
          :blue="true"
          text="Отменить"
          />
        </div>
      </div>
    </div>
  </BaseModalWindow>
</template>

<script>
import { useStore } from 'vuex'
import { ref, computed } from 'vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import InputText from 'primevue/inputtext'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'ChangeTagsModal',
  components: {
    BaseModalWindow,
    InputText,
    BaseBtnNew,
    SaveIconNew
  },
  props: {
    activitiesId: {
      type: Number,
      default: null
    },
    changeTags: {
      type: Boolean,
      default: true
    }
  },
  setup (props) {
    const store = useStore()

    const tagsObj = computed(() => {
      return store.getters.getChangeTagsObj
    })

    const keywordsObj = computed(() => {
      return store.getters.getChangeKeywordsObj
    })

    const selectDirection = ref(null)

    const saveChangeTags = () => {
      // разделение логики на два проекта с привязкой к значению из localStorage
      if (localStorage.activeProject === 'site') {
        // разделение логики на две сущности: теги и ключевые слова, с привязкой к props.changeTags
        if (props.changeTags === true) {
          const obj = {
            Id: tagsObj.value.Id,
            Name: tagsObj.value.Name,
            UniversalTagId: tagsObj.value.UniversalTagId,
            Category: props.activitiesId
          }
          store.dispatch('setChangeTagsData', obj)
          store.commit('SetShowChangeTagsEditor', false)
        } else {
          const obj = {
            Id: keywordsObj.value.Id,
            Name: keywordsObj.value.Name,
            Category: props.activitiesId
          }
          store.dispatch('setChangeKeywordsData', obj)
          store.commit('SetShowChangeTagsEditor', false)
        }
      } else if (localStorage.activeProject === 'education') {
        if (props.changeTags === true) {
          const obj = {
            Id: tagsObj.value.Id,
            Name: tagsObj.value.Name
          }
          store.dispatch('setChangeTagsEducationData', obj)
        } else {
          const obj = {
            Id: keywordsObj.value.Id,
            Name: keywordsObj.value.Name
          }
          store.dispatch('setChangeKeywordsDataEducation', obj)
        }
      }
      store.commit('SetShowChangeTagsEditor', false)
    }

    const closeChangeTagsModal = () => {
      store.commit('SetShowChangeTagsEditor', false)
    }

    return {
      closeChangeTagsModal,
      selectDirection,
      tagsObj,
      keywordsObj,
      saveChangeTags
    }
  }
}
</script>

<style lang="scss" scoped>
  .change-tags {
    width: 710px;
  }

  .tags {
    margin-top: 40px;

    &__input {
      display: flex;
      flex-direction: column;
      margin-bottom: 40px;
      text-align: left;
      font-weight: 500;
      font-size: 18px;
      line-height: 1.4;
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 24px;
    }
  }

  :deep(.base-button) {
    width: 200px;
  }
  :deep(.footer) {
    justify-content: flex-end !important;
  }

  :deep(.p-inputtext) {
    border: 1px solid #000000;
    // -webkit-box-shadow: inset 0 0 0 50px white;
  }

  :deep(.p-inputtext:enabled:hover) {
    border-color: #00ABEC;
  }
  :deep(.p-inputtext:disabled) {
    opacity: 0.5;
  }

  :deep(.p-inputtext:enabled:focus) {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.1rem #00ABEC;
    border-color: #00ABEC;
    -webkit-box-shadow: inset 0 0 0 50px white;
  }
  :deep(.p-inputnumber) {
    width: 100%;
    max-width: 800px;
  }
</style>
